import type { NotificationItemBasicInfo } from './notificationItemBasicInfo';
import type { NotificationItemData } from './notificationItemData';
import type { NotificationItemSource } from './notificationItemSource';
import type { NotificationItemStatus } from './notificationItemStatus';
import type { NotificationItemTarget } from './notificationItemTarget';

export interface NotificationItem {
  basicInfo: NotificationItemBasicInfo;
  /** @nullable */
  data?: NotificationItemData;
  source?: NotificationItemSource;
  status: NotificationItemStatus;
  target?: NotificationItemTarget;
}
